var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unauthorized-content"},[_vm._v("\n    You are not authorized to view this page\n")])}
var staticRenderFns = []

export { render, staticRenderFns }